import { useMemo } from 'react';
import { useSharedTripQuery } from './useTripsQueries';
import {
  errorHandler,
  isProcessedError,
  type ProcessedError,
} from '../services/utils/errorHandler';
import type { TripDetail } from '../types';

export function usePublicItinerary(shareToken: string) {
  const tripQuery = useSharedTripQuery(shareToken);

  const error: ProcessedError | null = useMemo(() => {
    if (tripQuery.isLoading || tripQuery.data) {
      return null;
    }
    if (tripQuery.isError && tripQuery.error != null) {
      return isProcessedError(tripQuery.error)
        ? tripQuery.error
        : errorHandler.processError(tripQuery.error as Error);
    }
    if (!tripQuery.isLoading && !tripQuery.data) {
      return errorHandler.processError(
        new Error('Trip not found or link is no longer valid.')
      );
    }
    return null;
  }, [tripQuery.isLoading, tripQuery.isError, tripQuery.error, tripQuery.data]);

  return {
    trip: tripQuery.data as TripDetail | undefined,
    isLoading: tripQuery.isLoading,
    error,
  };
}
